// JsFromRoutes CacheKey 13289de211878ef93ddb72dea34eb2a3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/theses/:thesis_id/thesis_updates'),
  show: /* #__PURE__ */ definePathHelper('get', '/theses/:thesis_id/thesis_updates/:id'),
}
